import Helmet from "react-helmet";

const HelmetUTP = ({
    title, 
    children
}) => {
    return (
        <Helmet>
            <title>UTP Reservas{title ? ` | ${title}` : ""}</title>
            {children}
        </Helmet>
    );
}


export default HelmetUTP;